import { getAdminUrl } from './getAdminUrl';
import { getCurrentOrg } from '@api/getCurrentOrg';

type GetExternalConversationUrlParams = {
  conversationId?: string;
};

export const getExternalConversationUrl = ({
  conversationId,
}: GetExternalConversationUrlParams) => {
  if (!conversationId) return;
  const organization_id = getCurrentOrg();

  return `${getAdminUrl(false)}/conversation/${organization_id}/${conversationId}`;
};
